import {
  getAccessToken,
  isRegistration,
  getIdpHint
} from '@/components/callback/callBack.service';
import keyClockConfig, { LoginConstants } from '@/config/keyClock.config';
import {
  generateCodeVerifier,
  generateCodeChallengeFromVerifier
} from '@/services/pkce';

export const checkToken = (): boolean => {
  const accessToken = getAccessToken();
  if (!accessToken) {
    const codeVerifier = generateCodeVerifier();
    getCodeChallengeAndInitiateKeyClockLogin(codeVerifier);
    return true;
  } else {
    return false;
  }
};

export const getCodeChallengeAndInitiateKeyClockLogin = async (
  codeVerifier: string
) => {
  try {
    sessionStorage.setItem(LoginConstants.CODE_VERIFIER, codeVerifier);
    const codeChallenge: string =
      await generateCodeChallengeFromVerifier(codeVerifier);

    const isReg = isRegistration();
    sessionStorage.removeItem(LoginConstants.IS_REGISTER);

    // An invited user can arrive from the Keycloak set-password page with an
    // IdP hint (?idp=google captured by Loader). Forward it as kc_idp_hint so
    // Keycloak sends them straight to Google instead of the IdP picker.
    const idpHint = getIdpHint();
    sessionStorage.removeItem(LoginConstants.IDP_HINT);
    const idpHintParam = idpHint ? `&kc_idp_hint=${idpHint}` : '';

    const URL: string = `${keyClockConfig.issuer}/auth?client_id=${keyClockConfig.clientId}&response_type=${LoginConstants.CODE}&code_challenge=${codeChallenge}&code_challenge_method=${LoginConstants.CODE_CHALLENGE_METHOD}&redirect_uri=${keyClockConfig.redirectUri}&is_register=${isReg}${idpHintParam}`;
    location.replace(URL);
  } catch (e) {
    console.error('error');
  }
};
